/**
 * The task BOARD's edit baseline (`TeamTaskBoard.js`: Kanban/Gantt drag and the
 * add-task default): a per-task edit predicate evaluated against a task with NO
 * creator, so a "created_by === me" arm drops out and only its manager-level
 * base remains. A plain boolean passes through.
 *
 * Its own file so another chart of the same tasks (the Breakdown Timeline,
 * through `gags/gagTaskPlanning.js`) gates its drags on the SAME answer.
 * 🪤 Not exported from `TeamTaskBoard.js` itself: nine suites `jest.mock` that
 * module wholesale, which would hand a named import back as `undefined`.
 */
export const boardBaselineCanEdit = (canEdit) => (typeof canEdit === 'function' ? !!canEdit({}) : !!canEdit);
